module.exports = __webpack_public_path__ + "static/media/drawer_background.d34ae2dc.png";